import { handleActions } from 'redux-actions';
import { reduxModuleLoaded, overrideSubscribeMatureFilter } from './actions';
import { TierConsumerStoreSlice } from './types';

const reducers = handleActions<TierConsumerStoreSlice, any>(
  {
    [reduxModuleLoaded.toString()]: (state, action: ReturnType<typeof reduxModuleLoaded>) => ({
      ...state,
      reduxReady: true,
    }),
    [overrideSubscribeMatureFilter.toString()]: (
      state,
      { payload }: ReturnType<typeof overrideSubscribeMatureFilter>
    ) => ({
      ...state,
      matureFilterOverrides: [payload.tier.deviationId, ...state.matureFilterOverrides],
    }),
  },
  {
    reduxReady: false,
    matureFilterOverrides: [],
  }
);
export default reducers;
